import React, { useEffect } from 'react';

import { RouterCategories } from '../router';

import { Header, Footer, Breadcrumb, MobileMenuModal, Modal } from '../components';
import { Loader } from '../ui';
import { Provider, Consumer } from '../context';
import { lastPage } from '../utilities';

const DefaultLayout = props => {
  const [state, setState] = React.useState({
    loading: false,
    pageClassName: '',
  });

  useEffect(() => {
    const { pathname } = props.location || {};

    const extract = (pathname && pathname.split('/')) || [];

    setState({
      loading: false,
      pageClassName: extract.length > 1 ? extract[1] : '',
    });
    lastPage.setLastPage(props.location);
  }, [props.location]);

  return (
    <Provider {...props}>
      <Consumer>
        {value => {
          return (
            <div className={`page ${state.pageClassName}`}>
              <section className="section section-header">
                <Header />
              </section>
              <section className="section section-breadcrumb">
                <Breadcrumb />
              </section>
              <main className={`main container`}>
                {(!state.loading && <RouterCategories {...props} />) || <Loader />}
              </main>
              <section className="section section-footer">
                <Footer />
              </section>
              <MobileMenuModal open={value.mobileMenuOpen} />
              <Modal open={value.modalOpen} />
            </div>
          );
        }}
      </Consumer>
    </Provider>
  );
};

export default DefaultLayout;
